/**
 * CV / résumé manifest for the dedicated /cv page.
 *
 * HOW TO SWAP IN THE REAL CV:
 *  1. Export your CV as a PDF and drop it in public/cv/, replacing
 *     ellen-boakye-cv.pdf (or update `file` below to a new filename).
 *  2. Page count/thumbnails are detected automatically, nothing else
 *     to configure.
 */
const cv = {
  file: "ellen-boakye-cv.pdf",
  title: "Ellen Boakye CV",
  updated: "2026",
};

export default cv;
